export default "__VITE_ASSET__DEl_lTod__"